import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridCustomPagination } from "components/helpers";
import { getPracticeScribingStatusDetails } from "apiHandler/actions";
import { Close } from "@mui/icons-material";
import { trimmedDate } from "utils/helper";

const columns = [
  {
    field: "dos",
    headerName: "DOS",
    width: 150,
    renderCell: (e) => <div>{trimmedDate(e.value)}</div>,
  },
  {
    field: "first_name",
    headerName: "Name",
    width: 200,
    renderCell: (e) => <div>{`${e.value} ${e.row.last_name}`}</div>,
  },
  { field: "adv_chart_status", headerName: "Advance Charting", width: 150 },
  { field: "dictation_id", headerName: "DictationID", width: 100 },
  { field: "scribing_status", headerName: "Scribing", width: 100 },
  { field: "coding_review_status", headerName: "Coding", width: 100 },
  { field: "comments", headerName: "Notes", width: 200 },
];

const SummaryDetails = ({ open, onClose, userData, dos }) => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (dos) {
      getDetails();
    }
  }, [dos]);

  const getDetails = async () => {
    setLoading(true);
    setRows([]);
    try {
      const payload = {
        type: "Dictation",
        search_criteria: {
          practice_id: userData?.selected_practice,
          dos,
          condition: "incomplete_scribing",
        },
      };
      const res = await getPracticeScribingStatusDetails(
        payload,
        userData?.access_token
      );

      if (res && res.length > 0) {
        setRows(res);
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <DialogTitle>Detail View</DialogTitle>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <Box sx={{ height: 450, width: "100%" }}>
          <DataGrid
            autoHeight
            rows={rows}
            columns={columns}
            loading={loading}
            pageSize={10}
            slotProps={{
              loadingOverlay: {
                variant: "linear-progress",
                noRowsVariant: "linear-progress",
              },
            }}
            slots={{
              pagination: DataGridCustomPagination,
              toolbar: GridToolbar,
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SummaryDetails;
